'use strict';

// TODO this is a placeholder for the Add Project Contributors modal
// For now just static with text Feature Coming Soon. Two heads are better than one.
// as requested https://arrowecommerce.atlassian.net/browse/BKT-707

var Backbone = require('backbone'),
  $ = require('jquery'),
  ModalView = require('../../js/components/ModalView'),
  ProjectDetailsAddUsersModal = Backbone.View.extend({

    initialize: function() {
      this.$infoModal = $('.AddUsersModal');
    },

    events: {
      click: 'open'
    },

    open: function() {
      if (!this.infoModal) {
        this.infoModal = new ModalView({
          content: this.$infoModal

        });

      }
      this.infoModal.open();
      return false;
    }

  }, {
    create: function($parent) {
      $parent.find('.js-projectDetailsAddUsers').each(function(n, el) {
        new ProjectDetailsAddUsersModal({
          el: el
        });
      });
    }
  });

module.exports = ProjectDetailsAddUsersModal;


// WEBPACK FOOTER //
// ./assets/components/DesignCenter/projectDetailsAddUsersModal.js